import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { Card, PageTitle } from "@/components/portal/ui";

export default function Timeline() {
  const [events, setEvents] = useState([]);
  useEffect(() => { http.get("/portal/timeline").then((r) => setEvents(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <PageTitle eyebrow="History" title="Your timeline" sub="Every purchase, report, plan, and update — in one continuous record." />
      <Card className="p-7">
        {events.length === 0 ? <p className="text-[#6B665E] text-sm">Nothing yet.</p> : (
          <div className="relative pl-6">
            <div className="absolute left-[7px] top-2 bottom-2 w-px bg-[#E5E1D8]" />
            <div className="space-y-6">
              {events.map((e) => (
                <div key={e.id} className="relative">
                  <span className="absolute -left-6 top-1 w-3.5 h-3.5 rounded-full bg-[#9F634E] border-2 border-white" />
                  <div className="text-xs text-[#8A998C]">{new Date(e.date).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}</div>
                  <div className="text-[#1A1918] text-[15px] mt-0.5">{e.label}</div>
                </div>
              ))}
            </div>
          </div>
        )}
      </Card>
    </div>
  );
}
